import { create } from 'zustand';

import { type MentionItem } from '../ui/components/ChatComposer/mentions/types';

type BrandKitMentionStore = {
  mentions: MentionItem[];
  setMentions: (mentions: MentionItem[]) => void;
};

export const useBrandKitMentionStore = create<BrandKitMentionStore>((set) => ({
  mentions: [],
  setMentions: (mentions) => set({ mentions }),
}));

export const getBrandKitMentions = () => useBrandKitMentionStore.getState().mentions;
